const routes = {
  HOME: '/',
  CONTACT: '/contact',
  ABOUT: '/',
  QUIZ: '/survey',
  WASP_P: '/wasp-p',
  ERROR: '/error',
  TEAM: '/team'
}

export default routes;
